module.exports = __webpack_public_path__ + "static/media/cliente-juriti.35860d51.webp";